import Cookie from 'js-cookie';

export const getTargetCookie = (key: string) => {
    return Cookie.get(key);
};

export const setCookie = (key: string, value: string) => {
    Cookie.set(key, value);
};